import React from 'react';

function Footer() {
  return (
    <div className="bg-[#0C1E1B] text-white py-[50px] md:py-[100px]">
      <div className="container">
        <footer className="flex justify-between items-center">
          <div className="flex flex-col md:px-10">
            <a href='#'>
              <img src="/images/common/logo.png" className="max-h-[40px]"></img>
            </a>
          </div>
          <div className="flex flex-col md:flex-row w-full text-right items-center">
            <div className="flex flex-col w-full md:px-10">
              <a href="#">Twitter</a>
            </div>
          <div className="flex flex-col w-full md:px-10">
            <a href="#">Privacy Policy</a>
          </div>
          <div className="flex flex-col w-full md:px-10">
            <a href="#">Terms of Service</a>
          </div>
          <div className="flex flex-col w-full md:px-10">
            <a href="#">System Status</a>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default Footer;
